import ActionTypes from "./ActionTypes.js";
class Actions {
  updateActiveProgressionsListPropsData(payload) {
    return {
      type: ActionTypes.UPDATE_ACTIVE_PROGRESSION_LIST_PROPS_DATA,
      payload
    };
  }
}
const ActionProgressionsActions = new Actions();
export {
  Actions,
  ActionProgressionsActions as default
};
//# sourceMappingURL=Actions.js.map
